import { useState } from "react";
import { PropTypes } from "prop-types";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import Lang from "components/Lang";

export const PasswordModifierModal = ({ username, submit, onExited, backdrop }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [visible, setVisible] = useState(true);
  const [failed, setFailed] = useState(false);

  const checkSubmittable = () => Boolean((currentPassword && password1 && password2) && (password1 === password2));
  const close = () => setVisible(false);
  const submitHandler = (event) => {
    event.preventDefault();
    if (!checkSubmittable()) {
      return;
    }
    setFailed(false);
    submit(currentPassword, password1)
      .then(close)
      .catch((error) => {
        console.error(error); // eslint-disable-line no-console
        setFailed(error);
      });
  };
  return (
    <Modal
      className="modal-container"
      show={visible}
      onHide={close}
      onExited={onExited}
      backdrop={backdrop || "static"}
      animation={true}
    >
      <Form onSubmit={submitHandler}>
        <Modal.Header closeButton>
          <div className="h6 mb-0"><Lang>パスワード変更</Lang>: {username}</div>
        </Modal.Header>
        <Modal.Body>
          {Boolean(failed) && (
            <Alert variant="warning">
              <p className="mb-0"><Lang>変更できませんでした。</Lang></p>
              <ul className="mb-0">
                <li><Lang>現在のパスワードは正しいですか。</Lang></li>
                <li><Lang>パスワード確認が一致していますか。</Lang></li>
                <li><Lang>ルールに合致していますか。</Lang></li>
              </ul>
            </Alert>
          )}
          <Form.Group className="mb-3">
            <Lang> {/* TODO placeholder 現在のパスワード */}
              <Form.Control
                type="password"
                value={currentPassword}
                className="w-75"
                placeholder="現在のパスワード"
                onChange={(event) => setCurrentPassword(event.target.value)}
              />
            </Lang>
          </Form.Group>
          <hr />
          <Form.Group className="my-3">
            <Lang> {/* TODO placeholder 新しいパスワード */}
              <Form.Control
                type="password"
                value={password1}
                className="w-75"
                placeholder="新しいパスワード"
                onChange={(event) => setPassword1(event.target.value)}
              />
            </Lang>
          </Form.Group>
          <Form.Group className="mb-3">
            <Lang> {/* TODO placeholder 新しいパスワード（確認） */}
              <Form.Control
                type="password"
                value={password2}
                className="w-75"
                placeholder="新しいパスワード（確認）"
                onChange={(event) => setPassword2(event.target.value)}
              />
            </Lang>
            <Form.Text muted><Lang>半角英数記号 8文字以上 大文字/小文字/数字必須</Lang></Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={close}>
            <Lang>キャンセル</Lang>
          </Button>
          <Button variant="primary" type="submit" disabled={!checkSubmittable()}>
            <Lang>設定</Lang>
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
PasswordModifierModal.propTypes = {
  submit:   PropTypes.func.isRequired,
  backdrop: PropTypes.string,
  onExited: PropTypes.func
};